import { assertScrubbed } from './scrubPII';

export function validateReportData(scrubbed) {
  assertScrubbed(scrubbed, 'validateReportData');

  const warnings = [];

  const unitsSold = Math.max(0, parseInt(scrubbed.unitsSold ?? 0, 10));
  const goal      = Math.max(0, parseInt(scrubbed.monthlyGoal ?? 0, 10));

  // ALWAYS recompute — never trust stored goalAttainment
  const goalAttainment = goal > 0 ? Math.round((unitsSold / goal) * 100) : 0;
  if ((scrubbed.goalAttainment ?? 0) === 0 && unitsSold > 0) {
    warnings.push('goalAttainment_contradiction_corrected');
  }

  const SELLING_DAYS = 22;
  const today              = new Date();
  const daysInMonth        = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
  const dayFraction        = today.getDate() / daysInMonth;
  const sellingDaysElapsed = scrubbed.sellingDaysElapsed
                             ?? Math.round(dayFraction * SELLING_DAYS);
  const sellingDaysRemaining = SELLING_DAYS - sellingDaysElapsed;
  const currentPacePerDay    = sellingDaysElapsed > 0
    ? parseFloat((unitsSold / sellingDaysElapsed).toFixed(2)) : 0;
  const projectedUnits = Math.round(currentPacePerDay * SELLING_DAYS);
  const paceToGoal     = goal > 0 ? Math.round((projectedUnits / goal) * 100) : 0;

  const callsMade  = Math.max(0, parseInt(scrubbed.callsMade  ?? 0, 10));
  const textsSent  = Math.max(0, parseInt(scrubbed.textsSent  ?? 0, 10));
  const emailsSent = Math.max(0, parseInt(scrubbed.emailsSent ?? 0, 10));
  const totalOutreach = callsMade + textsSent + emailsSent;

  const leadsContacted = Math.max(0, parseInt(scrubbed.leadsContacted ?? 0, 10));
  const leadsClosed    = Math.min(unitsSold, leadsContacted);
  const leadConversionRate = leadsContacted > 0
    ? Math.round((leadsClosed / leadsContacted) * 100)
    : null;  // null = insufficient data — not 0

  const commissionMTD   = Math.max(0, parseFloat(scrubbed.commissionMTD  ?? 0));
  const totalGrossMTD   = Math.max(0, parseFloat(scrubbed.totalGrossMTD  ?? 0));
  const avgGrossPerUnit = unitsSold > 0 ? Math.round(totalGrossMTD / unitsSold) : 0;

  const apptSet    = Math.max(0, parseInt(scrubbed.apptSet    ?? 0, 10));
  const apptShown  = Math.min(apptSet, Math.max(0, parseInt(scrubbed.apptShown  ?? 0, 10)));
  const apptClosed = Math.min(apptShown, Math.max(0, parseInt(scrubbed.apptClosed ?? 0, 10)));
  const apptSetRate   = leadsContacted > 0 ? Math.round((apptSet   / leadsContacted) * 100) : null;
  const apptShowRate  = apptSet   > 0      ? Math.round((apptShown  / apptSet)   * 100) : null;
  const apptCloseRate = apptShown > 0      ? Math.round((apptClosed / apptShown) * 100) : null;

  const dataQuality = !totalOutreach && !leadsContacted ? 'minimal'
                    : !leadsContacted || !apptSet        ? 'partial'
                    : 'full';

  return {
    repName:      scrubbed.repName ?? 'This Rep',
    reportingMonth: scrubbed.reportingMonth,
    reportingYear:  scrubbed.reportingYear,
    unitsSold, goal, goalAttainment, paceToGoal,
    sellingDaysElapsed, sellingDaysRemaining,
    currentPacePerDay, projectedUnits,
    commissionMTD, totalGrossMTD, avgGrossPerUnit,
    incomeGoal: scrubbed.incomeGoal ?? null,
    callsMade, textsSent, emailsSent, totalOutreach,
    zeroDays: scrubbed.zeroDays ?? 0,
    avgDailyActivity: sellingDaysElapsed > 0
      ? Math.round(totalOutreach / sellingDaysElapsed) : 0,
    leadsContacted, leadsClosed, leadConversionRate,
    apptSet, apptShown, apptClosed,
    apptSetRate, apptShowRate, apptCloseRate,
    firstTouchRate:  scrubbed.firstTouchRate  ?? null,
    secondTouchRate: scrubbed.secondTouchRate ?? null,
    unitsFirstWeek:  scrubbed.unitsFirstWeek  ?? null,
    unitsSecondWeek: scrubbed.unitsSecondWeek ?? null,
    unitsThirdWeek:  scrubbed.unitsThirdWeek  ?? null,
    unitsLastWeek:   scrubbed.unitsLastWeek   ?? null,
    dataQuality,
    _warnings: warnings,
    _validated: true,
    _scrubAudit: scrubbed._scrubAudit,
  };
}
